/**
 * Sur Excel Add-in Configuration
 */

export const config = {
  // API Configuration
  apiBaseUrl: "https://api.sur.bm/api/v1",

  // Token storage keys
  storageKeys: {
    accessToken: "sur_access_token",
    refreshToken: "sur_refresh_token",
    user: "sur_user",
  },

  // API endpoints
  endpoints: {
    auth: {
      login: "/auth/login",
      refresh: "/auth/refresh",
      logout: "/auth/logout",
      me: "/auth/me",
    },
    mappings: {
      list: "/mappings",
      upload: "/mappings/upload",
      bulk: "/mappings/bulk",
      template: "/mappings/template",
      summary: "/mappings/summary",
    },
    segments: {
      list: "/segments",
    },
  },

  // Request timeout in milliseconds
  requestTimeout: 30000,

  // Excel column mappings (expected headers)
  excelColumns: {
    customerCode: ["customer_code", "customercode", "customer code", "code", "id", "customer_id"],
    segmentName: ["segment_name", "segmentname", "segment name", "segment", "category"],
    notes: ["notes", "note", "comments", "comment", "remarks"],
  },
};

export default config;
